// TagInspector.js
import React from 'react';
export default function TagInspector(){
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Tag Inspector (TODO)</h2>
      <p>Tagging tools / show tag lists and manual edit UI.</p>
    </div>
  );
}
